import { KeyValue } from '@angular/common';
import { Component } from '@angular/core';
import { CsvAnalytic } from 'src/app/core/models/analytics.model';
import { Entity } from 'src/app/core/models/entity.model';
import { Groups } from 'src/app/core/models/group.model';
import { PackageType } from 'src/app/core/models/package-type.model';
import { Package } from 'src/app/core/models/package.model';
import { PaginationRequest } from 'src/app/core/models/pagination.model';
import { User } from 'src/app/core/models/user.model';
import * as utils from 'src/app/shared/helpers/utils';
import { ConfigService } from 'src/app/core/services/config.service';
import { CsvDataService } from 'src/app/core/services/export.service';
import { LicenseService } from 'src/app/core/services/license.service';

@Component({
  selector: 'hbo-analytics-packages',
  templateUrl: './analytics-packages.component.html',
  styleUrls: ['./analytics-packages.component.scss']
})
export class AnalyticsPackagesComponent {


  action = 'analyticPackages';
  parentEntities: Entity[] = [];

  beforeEntity!: Entity| null;
  focusedEntity!: Entity | null;

  groups: Groups = new Groups;

  classification$!: { [key: string | number]: Package[] };

  allPackageTypes: PackageType[] = [];

  user: User = utils?.localStorageGetItem('user');

  constructor(
    public configSvc: ConfigService,
    private licensesSvc: LicenseService,
    private csvDataService: CsvDataService
  ) {
    this.parentEntities = this.configSvc.currentConfigValue.childEntities!.filter((entity: Entity) => entity.entityTypeId !== 4);
    !this.configSvc.currentConfigValue.packageTypes
      ? this.licensesSvc.getPackageTypes().subscribe(packageTypes => {
        this.allPackageTypes = packageTypes.data;
        this.configSvc.setConfigParamsValue('packageTypes', this.allPackageTypes);
      })
      : this.allPackageTypes = this.configSvc.currentConfigValue.packageTypes;

  }

  ngOnInit() {
    if (this.user.roleId !== 1) {
      this.getPackages();
    }
  }

  onChange(id: number, _type?: string) {
    this.beforeEntity = this.configSvc.currentConfigValue.childEntities!.find((entity: Entity) => entity.id === id)!;
    switch (_type) {
      default:
        break;
    }
  }

  getPackages(e?: Event) {
    this.configSvc.resetAnalyticsPackagesCollectionAcumulateValue();
    this.beforeEntity ?
      this.focusedEntity = this.configSvc.currentConfigValue.childEntities!.find((entity: Entity) => entity.id === this.beforeEntity?.id)!
      : this.focusedEntity = null;
    const perPage = 500;
    let page = 1;
    let lastPage = 0;
    let total = 0;

    //if admin role,  in case focused entity dist add to search ho entities
    let entitiesString = this.focusedEntity?.id.toString();
    if (this.user.roleId === 1 && this.focusedEntity) {
      if (this.focusedEntity?.entityTypeId === 2) {
        const hoList = this.configSvc.currentConfigValue.entities.filter((entity: Entity) => entity.parentEntityId === this.focusedEntity!.id)?.map((entity: Entity) => entity.id)?.join(',');
        entitiesString = `${entitiesString}${hoList ? ',' + hoList : ''}`
      }
    }

    const pagination: PaginationRequest = {
      page: 1,
      sort: 'id',
      order: 'asc',
      entities: this.focusedEntity ? '[' + entitiesString + ']' : null
    };
    pagination.perPage = perPage;
    this.iterateCSVLicenses(pagination, perPage, page, lastPage, total)
  }

  iterateCSVLicenses = (_pagination: PaginationRequest, _perPage: number, _page: number, _lastPage: number, _total: number) => {
    _pagination.page = _page;
    this.licensesSvc.indexPackages(_pagination).subscribe(packages => {
      _total = packages.total
      _lastPage = packages.lastPage
      this.configSvc.setAnalyticsPackagesCollectionAcumulateValue(packages.data);
      if (_page == _lastPage || !packages.data.length) {
        this.classifyPackages();
      } else {
        _page++;
        this.iterateCSVLicenses(_pagination, _perPage, _page, _lastPage, _total)
      }
    });
  }

  classifyPackages = () => {
    this.classification$ = {};
    Object.keys(this.groups).map(key => {
      this.groups[key].map((type: number) => {
        if (this.configSvc.currentConfigValue.analytics?.packages.filter((pack: Package) => pack.packageTypeId === type).length)
          this.classification$[type] = this.configSvc.currentConfigValue.analytics?.packages.filter((pack: Package) => pack.packageTypeId === type)!;
      })
    });
  }
  compareByKeyDesc(a: KeyValue<string, Package[]>, b: KeyValue<string, Package[]>): number {
    // We convert keys to numbers for correct comparison (if they are string-numeric)
    const keyA = +a.key;
    const keyB = +b.key;

    // Sort descending (b - a)
    // Sort ascending (a - b)
    return keyB - keyA;
  }
  getPackageName = (_id: string) => {
    return this.allPackageTypes?.find((type: PackageType) => type.id === Number(_id))?.name;
  }

  getTotals = (_type: string, _category: number | null | undefined, _status?: number | null | undefined) => {
    switch (_category) {
      case undefined:
      case null:
        switch (_status) {
          case undefined:
          case null:
            return this.getTotalsByPackageType(_type);
          default:
            return this.getTotalsByPackageTypeStatus(_type, _category!, _status!)
        }
      default:
        switch (_status) {
          case undefined:
          case null:
            return this.getTotalsByCategoryPackageType(_type, _category!, _status!)
          default:
            return this.getTotalsByCategoryPackageTypeStatus(_type, _category!, _status!);
        }
    }
  }
  getTotalsByCategory = (_id: number) => {
    return this.classification$[_id].length
  }
  getTotalsByPackageType = (_type: string) => {
    return this.classification$[_type].length
  }
  getTotalsByCategoryAndPackageType = () => {

  }
  getTotalsByPackageTypeStatus = (_type: string, _category: number, _status: number) => {
    return this.classification$[_type].filter((pack: Package) => pack.packageStatusId === _status).length
  }
  getTotalsByCategoryPackageType = (_type: string, _category: number, _status: number) => {
    return this.classification$[_type].filter((pack: Package) => pack.packageCategoryId === _category).length
  }
  getTotalsByCategoryPackageTypeStatus = (_type: string, _category: number, _status: number) => {
    return this.classification$[_type].filter((pack: Package) => pack.packageCategoryId === _category && pack.packageStatusId === _status).length
  }

  getTotalsInactive = (_type: string, _category: number | null | undefined, _reason?: string | null | undefined) => {
    switch (_category) {
      case undefined:
      case null:
        switch (_reason) {
          case 'IR':
            return this.classification$[_type].filter((pack: Package) => pack.packageStatusId === 5 && pack.inactiveRequestDate).length;
          case 'M':
            return this.classification$[_type].filter((pack: Package) => pack.packageStatusId === 5 && !pack.inactiveRequestDate && pack.packageUpgradeId).length;
          case 'CU':
            return this.classification$[_type].filter((pack: Package) => pack.packageStatusId === 5 && !pack.inactiveRequestDate && !pack.activationDate && pack.packageOriginId && !pack.packageUpgradeId).length;
          case 'B':
            return this.classification$[_type].filter((pack: Package) => pack.packageStatusId === 5 && !pack.inactiveRequestDate && !pack.packageUpgradeId && !pack.packageOriginId).length;
          default:
            return
        }
      default:
        switch (_reason) {
          case 'IR':
            return this.classification$[_type].filter((pack: Package) => pack.packageStatusId === 5 && pack.packageCategoryId === _category && pack.inactiveRequestDate).length;
          case 'M':
            return this.classification$[_type].filter((pack: Package) => pack.packageStatusId === 5 && pack.packageCategoryId === _category && !pack.inactiveRequestDate && pack.packageUpgradeId).length;
          case 'CU':
            return this.classification$[_type].filter((pack: Package) => pack.packageStatusId === 5 && pack.packageCategoryId === _category && !pack.inactiveRequestDate && !pack.activationDate && pack.packageOriginId && !pack.packageUpgradeId).length;
          case 'B':
            return this.classification$[_type].filter((pack: Package) => pack.packageStatusId === 5 && pack.packageCategoryId === _category && !pack.inactiveRequestDate && !pack.packageUpgradeId && !pack.packageOriginId).length;
          default:
            return
        }
    }
  }

  downloadSummary = () => {
    let rows: CsvAnalytic[] = [];
    Object.keys(this.classification$).map(key => {
      if (this.classification$[key].length) {
        rows.push({
          Type: this.getPackageName(key),
          Category: 'Demo',
          Packages: this.getTotals(key, 2),
          Assigned: this.getTotals(key, 2, 1),
          Test: this.getTotals(key, 2, 2),
          InUpgrade: '-',
          Active: '-',
          InactiveRequest: '-',
          InactiveIR: '-',
          InactiveM: this.getTotalsInactive(key, 2, 'M'),
          InactiveCU: '-',
          InactiveB: this.getTotalsInactive(key, 2, 'B')
        });
        rows.push({
          Type: '',
          Category: 'Operative',
          Packages: this.getTotals(key, 1),
          Assigned: this.getTotals(key, 1, 1),
          Test: this.getTotals(key, 1, 2),
          InUpgrade: this.getTotals(key, 1, 6),
          Active: this.getTotals(key, 1, 3),
          InactiveRequest: this.getTotals(key, 1, 4),
          InactiveIR: this.getTotalsInactive(key, 1, 'IR'),
          InactiveM: this.getTotalsInactive(key, 1, 'M'),
          InactiveCU: this.getTotalsInactive(key, 1, 'CU'),
          InactiveB: this.getTotalsInactive(key, 1, 'B')
        });

        rows.push({
          Type: '',
          Category: '',
          Packages: this.getTotals(key, null, null),
          Assigned: this.getTotals(key, null, 1),
          Test: this.getTotals(key, null, 2),
          InUpgrade: this.getTotals(key, null, 6),
          Active: this.getTotals(key, null, 3),
          InactiveRequest: this.getTotals(key, null, 4),
          InactiveIR: this.getTotalsInactive(key, null, 'IR'),
          InactiveM: this.getTotalsInactive(key, null, 'M'),
          InactiveCU: this.getTotalsInactive(key, null, 'CU'),
          InactiveB: this.getTotalsInactive(key, null, 'B')
        });
      }
    })


    this.csvDataService.downloadFile(rows, `analytics_${(this.focusedEntity ? this.focusedEntity?.name : this.user.entity.name)}_${new Date}`, ['Type', 'Category', 'Packages', 'Assigned', 'Test', 'InUpgrade', 'Active', 'InactiveRequest', 'InactiveIR', 'InactiveM', 'InactiveCU', 'InactiveB'])

  }

  someHO=()=>{
   if(this.configSvc.currentConfigValue.entities?.filter((entity:Entity)=>entity.entityTypeId === 3).length) return true
   else return false
  }

}
